import React, { MutableRefObject } from "react";
import { useStoreRoom, useStoreSystem } from "../../../store";
import TireRackObject from "./components/TireRackObject";
import shallow from "zustand/shallow";

interface TireRacksListProps {
    moveCameraEnabled: MutableRefObject<boolean>;
}

const TireRacksList: React.FC<TireRacksListProps> = React.memo((props) => {
    const { moveCameraEnabled } = props;
    const tireRacks = useStoreRoom((state) => state.tireRacks, shallow);

    return (
        <group>
            {tireRacks.map((tireRack) => (
                <TireRackObject key={tireRack.id} tireRack={tireRack} moveCameraEnabled={moveCameraEnabled} />
            ))}
        </group>
    );
});

export default TireRacksList;
